// src/components/shared/WhatsAppAuthModal.jsx
// ✅ SMS working | WhatsApp pending new credentials
// ✅ SVG icons only (no emojis)
// ✅ Demo placeholder number
import React, { useState } from 'react';
import { useCustomerAuth } from '../../context/CustomerAuthContext';

const Spin = () => (
  <span style={{
    display:'inline-block',width:'.9rem',height:'.9rem',
    border:'2px solid rgba(255,255,255,.35)',borderTopColor:'white',
    borderRadius:'50%',animation:'wam-spin .7s linear infinite',flexShrink:0,
  }}/>
);

// SVG Icons
const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.07 1.18 2 2 0 012.07 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);
const IconUser = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
  </svg>
);
const IconWhatsApp = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);
const IconSMS = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconArrowLeft = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
  </svg>
);
const IconX = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);
const IconMilk = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 2h8l1 4H7L8 2z"/><path d="M7 6l-2 14h14L17 6H7z"/><path d="M9 11c0 1.1.9 2 2 2s2-.9 2-2"/>
  </svg>
);

const WhatsAppAuthModal = ({ onSuccess, onClose }) => {
  const { sendOtp, verifyOtp, saveName } = useCustomerAuth();

  const [step,     setStep]     = useState('phone');
  const [channel,  setChannel]  = useState('whatsapp');
  const [phone,    setPhone]    = useState('');
  const [otp,      setOtp]      = useState('');
  const [name,     setName]     = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [resendIn, setResendIn] = useState(0);

  const startCountdown = () => {
    setResendIn(60);
    const t = setInterval(() => setResendIn(p => {
      if (p <= 1) { clearInterval(t); return 0; }
      return p - 1;
    }), 1000);
  };

  const handleSendOtp = async (e) => {
    e && e.preventDefault();
    setError('');
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length < 10) { setError('Enter a valid 10-digit mobile number'); return; }
    setLoading(true);
    try {
      const data = await sendOtp(cleaned, channel);
      if (data.success) {
        setStep('otp');
        startCountdown();
      } else {
        setError(data.message || 'Could not send OTP. Try again.');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e && e.preventDefault();
    setError('');
    if (otp.length !== 6) { setError('Enter the 6-digit OTP'); return; }
    setLoading(true);
    try {
      const data = await verifyOtp(phone.replace(/\D/g, ''), otp);
      if (data.success) {
        if (!data.customer.name) {
          setStep('name');
        } else {
          onSuccess && onSuccess(data.customer);
        }
      } else {
        setError(data.message || 'Invalid OTP. Please try again.');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveName = async (e) => {
    e && e.preventDefault();
    setError('');
    if (!name.trim()) { setError('Please enter your name'); return; }
    setLoading(true);
    try {
      const data = await saveName(name.trim());
      if (data.success) {
        onSuccess && onSuccess(data.customer);
      } else {
        setError(data.message || 'Could not save name.');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const channelLabel = channel === 'sms' ? 'SMS' : 'WhatsApp';

  const stepNum = step === 'phone' ? 1 : step === 'otp' ? 2 : 3;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
        @keyframes wam-spin { to { transform: rotate(360deg); } }
        @keyframes wam-up {
          from { opacity:0; transform: translateY(24px) scale(.97); }
          to   { opacity:1; transform: none; }
        }

        .wam-ov {
          position:fixed; inset:0; z-index:999;
          background:rgba(0,0,0,.52); backdrop-filter:blur(5px);
          display:flex; align-items:center; justify-content:center;
          padding:1rem; font-family:'Nunito',sans-serif;
        }
        .wam-card {
          width:100%; max-width:400px; background:white;
          border-radius:1.5rem; overflow:hidden;
          box-shadow:0 24px 60px rgba(0,0,0,.25);
          animation:wam-up .3s cubic-bezier(.34,1.56,.64,1);
        }

        /* ── Header ── */
        .wam-hdr {
          background:linear-gradient(135deg,#059669 0%,#0891b2 100%);
          padding:1.6rem 1.4rem 1.3rem;
          text-align:center; color:white; position:relative;
        }
        .wam-hdr-logo {
          width:3rem; height:3rem; border-radius:50%;
          background:rgba(255,255,255,.18);
          display:flex; align-items:center; justify-content:center;
          margin:0 auto .65rem;
        }
        .wam-hdr-logo svg { width:1.5rem; height:1.5rem; color:white; }
        .wam-hdr h2 { font-size:1.2rem; font-weight:900; margin:0 0 .2rem; letter-spacing:-.01em; }
        .wam-hdr p  { font-size:.8rem; opacity:.9; margin:0; font-weight:600; }
        .wam-cl {
          position:absolute; top:.85rem; right:.85rem;
          background:rgba(255,255,255,.2); border:none; color:white;
          border-radius:50%; width:1.8rem; height:1.8rem;
          display:flex; align-items:center; justify-content:center;
          cursor:pointer; transition:background .2s;
        }
        .wam-cl:hover { background:rgba(255,255,255,.35); }
        .wam-cl svg { width:.8rem; height:.8rem; }

        /* step bar */
        .wam-steps {
          display:flex; align-items:center; justify-content:center;
          gap:.3rem; margin-top:.85rem;
        }
        .wam-step {
          height:.38rem; border-radius:9999px;
          background:rgba(255,255,255,.35); transition:all .3s;
        }
        .wam-step.act { background:white; width:1.4rem; }
        .wam-step.done { background:rgba(255,255,255,.7); width:.38rem; }
        .wam-step.todo { width:.38rem; }

        /* ── Body ── */
        .wam-body { padding:1.4rem 1.35rem 1.5rem; }

        /* error */
        .wam-err {
          background:#fef2f2; border:1px solid #fecaca; color:#dc2626;
          border-radius:.65rem; padding:.5rem .75rem;
          font-size:.78rem; font-weight:700; margin-bottom:.85rem;
          display:flex; align-items:center; gap:.35rem;
        }
        .wam-err svg { width:.85rem; height:.85rem; flex-shrink:0; }

        /* channel cards */
        .wam-channels { display:grid; grid-template-columns:1fr 1fr; gap:.5rem; margin-bottom:.9rem; }
        .wam-ch {
          display:flex; flex-direction:column; align-items:center; gap:.22rem;
          padding:.65rem .4rem; border:2px solid #e5e7eb; border-radius:.9rem;
          background:white; cursor:pointer; font-family:'Nunito',sans-serif;
          transition:all .2s; position:relative;
        }
        .wam-ch:hover { border-color:#a7f3d0; background:#f9fffe; }
        .wam-ch.sel {
          border-color:#059669; background:#f0fdf4;
          box-shadow:0 0 0 3px rgba(5,150,105,.1);
        }
        .wam-ch-icon {
          width:2rem; height:2rem; border-radius:.5rem;
          display:flex; align-items:center; justify-content:center;
        }
        .wam-ch-icon svg { width:1.1rem; height:1.1rem; }
        .wam-ch-lbl { font-size:.74rem; font-weight:800; color:#374151; }
        .wam-ch.sel .wam-ch-lbl { color:#059669; }
        .wam-ch-sub { font-size:.62rem; color:#9ca3af; font-weight:600; }
        .wam-ch-sel {
          position:absolute; top:.35rem; right:.35rem;
          width:1rem; height:1rem; border-radius:50%;
          background:#059669; display:flex; align-items:center; justify-content:center;
        }
        .wam-ch-sel svg { width:.55rem; height:.55rem; color:white; }

        /* notice banner */
        .wam-notice {
          display:flex; align-items:center; gap:.4rem;
          border-radius:.65rem; padding:.45rem .75rem;
          font-size:.78rem; font-weight:700; margin-bottom:.9rem;
        }
        .wam-notice svg { width:.85rem; height:.85rem; flex-shrink:0; }
        .wam-notice.wa  { background:#dcfce7; border:1px solid #a7f3d0; color:#065f46; }
        .wam-notice.sms { background:#eff6ff; border:1px solid #bfdbfe; color:#1e40af; }

        /* label */
        .wam-lbl { display:block; font-size:.76rem; font-weight:700; color:#374151; margin-bottom:.28rem; }

        /* phone input row */
        .wam-ph-row {
          display:flex; border:2px solid #e5e7eb; border-radius:.7rem;
          overflow:hidden; transition:border-color .2s; margin-bottom:.3rem;
        }
        .wam-ph-row:focus-within { border-color:#059669; box-shadow:0 0 0 3px rgba(5,150,105,.1); }
        .wam-flag {
          display:flex; align-items:center; gap:.3rem;
          padding:0 .75rem; background:#f9fafb; border-right:1px solid #e5e7eb;
          font-size:.82rem; font-weight:700; color:#374151; white-space:nowrap; flex-shrink:0;
        }
        .wam-flag svg { width:.85rem; height:.85rem; color:#6b7280; }
        .wam-ph-inp {
          flex:1; border:none; outline:none;
          padding:.68rem .75rem; font-size:.95rem;
          background:transparent; font-family:'Nunito',sans-serif; font-weight:700;
        }
        .wam-ph-inp::placeholder { color:#d1d5db; font-weight:400; }

        /* regular input */
        .wam-inp {
          width:100%; padding:.68rem .9rem;
          border:2px solid #e5e7eb; border-radius:.7rem;
          font-size:.95rem; font-family:'Nunito',sans-serif;
          outline:none; transition:border-color .2s; box-sizing:border-box;
        }
        .wam-inp:focus { border-color:#059669; box-shadow:0 0 0 3px rgba(5,150,105,.1); }
        .wam-inp::placeholder { color:#d1d5db; }

        /* hint */
        .wam-hint { font-size:.7rem; color:#9ca3af; margin:.28rem 0 .85rem; font-weight:600; }

        /* OTP input */
        .wam-otp {
          width:100%; text-align:center; letter-spacing:.6rem;
          font-size:1.7rem; font-weight:900; padding:.75rem 1rem .75rem 1.6rem;
          border:2px solid #e5e7eb; border-radius:.7rem;
          outline:none; font-family:'Nunito',sans-serif;
          transition:border-color .2s; box-sizing:border-box;
          margin-bottom:.28rem;
        }
        .wam-otp:focus { border-color:#059669; box-shadow:0 0 0 3px rgba(5,150,105,.1); }

        /* primary button */
        .wam-btn-p {
          width:100%; padding:.78rem; border:none; border-radius:9999px;
          background:linear-gradient(135deg,#10b981,#059669);
          color:white; font-size:.92rem; font-weight:800;
          cursor:pointer; display:flex; align-items:center;
          justify-content:center; gap:.45rem;
          font-family:'Nunito',sans-serif;
          box-shadow:0 4px 14px rgba(5,150,105,.28);
          transition:all .25s; margin-top:.35rem;
        }
        .wam-btn-p:hover:not(:disabled) { transform:translateY(-2px); box-shadow:0 8px 20px rgba(5,150,105,.36); }
        .wam-btn-p:disabled { opacity:.6; cursor:not-allowed; transform:none; box-shadow:none; }
        .wam-btn-p svg { width:.9rem; height:.9rem; }

        /* ghost button */
        .wam-btn-g {
          width:100%; padding:.65rem; border:2px solid #e5e7eb;
          border-radius:9999px; background:none; color:#6b7280;
          font-size:.82rem; font-weight:700; cursor:pointer;
          display:flex; align-items:center; justify-content:center; gap:.35rem;
          font-family:'Nunito',sans-serif; transition:all .2s; margin-top:.5rem;
        }
        .wam-btn-g:hover { border-color:#d1d5db; color:#374151; background:#f9fafb; }
        .wam-btn-g svg { width:.75rem; height:.75rem; }

        /* resend */
        .wam-resend { text-align:center; font-size:.8rem; color:#6b7280; margin:.6rem 0 .45rem; }
        .wam-resend-btn {
          background:none; border:none; color:#059669; font-weight:700;
          cursor:pointer; font-family:'Nunito',sans-serif; font-size:.8rem;
        }
        .wam-resend-btn:disabled { color:#9ca3af; cursor:not-allowed; }

        /* sent to info */
        .wam-sent-info {
          background:#f8fafc; border-radius:.65rem;
          padding:.55rem .85rem; margin-bottom:.9rem;
          font-size:.8rem; color:#374151; font-weight:600;
          display:flex; align-items:center; gap:.4rem;
        }
        .wam-sent-info svg { width:.85rem; height:.85rem; color:#059669; flex-shrink:0; }
      `}</style>

      <div className="wam-ov" onClick={onClose}>
        <div className="wam-card" onClick={e => e.stopPropagation()}>

          {/* Header */}
          <div className="wam-hdr">
            <button className="wam-cl" onClick={onClose}><IconX/></button>
            <div className="wam-hdr-logo"><IconMilk/></div>
            <h2>Fresh Hills</h2>
            <p>
              {step === 'phone' && 'Login with OTP — quick & secure'}
              {step === 'otp'   && `Enter OTP sent via ${channelLabel}`}
              {step === 'name'  && 'One last step — your name'}
            </p>
            <div className="wam-steps">
              <span className={`wam-step ${stepNum===1?'act':stepNum>1?'done':'todo'}`}/>
              <span className={`wam-step ${stepNum===2?'act':stepNum>2?'done':'todo'}`}/>
              <span className={`wam-step ${stepNum===3?'act':'todo'}`}/>
            </div>
          </div>

          <div className="wam-body">

            {error && (
              <div className="wam-err">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width:'.85rem',height:'.85rem',flexShrink:0}}>
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {error}
              </div>
            )}

            {/* ── STEP 1: Channel + Phone ── */}
            {step === 'phone' && (
              <form onSubmit={handleSendOtp}>

                {/* Channel selector */}
                <div className="wam-channels">
                  <button type="button"
                    className={`wam-ch${channel==='whatsapp'?' sel':''}`}
                    onClick={() => setChannel('whatsapp')}>
                    <div className="wam-ch-icon" style={{background: channel==='whatsapp'?'#dcfce7':'#f3f4f6'}}>
                      <IconWhatsApp style={{color: channel==='whatsapp'?'#059669':'#9ca3af'}}/>
                    </div>
                    <span className="wam-ch-lbl">WhatsApp</span>
                    <span className="wam-ch-sub">Instant delivery</span>
                    {channel==='whatsapp' && <span className="wam-ch-sel"><IconCheck/></span>}
                  </button>
                  <button type="button"
                    className={`wam-ch${channel==='sms'?' sel':''}`}
                    onClick={() => setChannel('sms')}>
                    <div className="wam-ch-icon" style={{background: channel==='sms'?'#dbeafe':'#f3f4f6'}}>
                      <IconSMS style={{color: channel==='sms'?'#2563eb':'#9ca3af'}}/>
                    </div>
                    <span className="wam-ch-lbl">SMS</span>
                    <span className="wam-ch-sub">Text message</span>
                    {channel==='sms' && <span className="wam-ch-sel" style={{background:'#2563eb'}}><IconCheck/></span>}
                  </button>
                </div>

                {/* Notice */}
                <div className={`wam-notice ${channel==='sms'?'sms':'wa'}`}>
                  {channel==='whatsapp' ? <IconWhatsApp/> : <IconSMS/>}
                  OTP will be sent to your {channelLabel} number
                </div>

                {/* Phone field */}
                <label className="wam-lbl">Mobile Number</label>
                <div className="wam-ph-row">
                  <div className="wam-flag">
                    <IconPhone/> +91
                  </div>
                  <input
                    className="wam-ph-inp"
                    type="tel"
                    placeholder="98765 43210"
                    value={phone}
                    onChange={e => setPhone(e.target.value.replace(/\D/g,'').slice(0,10))}
                    required
                    autoFocus
                  />
                </div>
                <div className="wam-hint">Enter your 10-digit Indian mobile number</div>

                <button className="wam-btn-p" type="submit" disabled={loading}>
                  {loading
                    ? <><Spin/> Sending OTP…</>
                    : channel==='sms'
                      ? <><IconSMS/> Send OTP via SMS</>
                      : <><IconWhatsApp/> Send OTP via WhatsApp</>
                  }
                </button>
              </form>
            )}

            {/* ── STEP 2: OTP ── */}
            {step === 'otp' && (
              <form onSubmit={handleVerifyOtp}>
                <div className="wam-sent-info">
                  {channel==='whatsapp' ? <IconWhatsApp/> : <IconSMS/>}
                  OTP sent to <strong>+91 {phone}</strong> via {channelLabel}
                </div>

                <label className="wam-lbl">6-Digit OTP</label>
                <input
                  className="wam-otp"
                  type="number"
                  placeholder="000000"
                  value={otp}
                  onChange={e => setOtp(e.target.value.slice(0,6))}
                  required
                  autoFocus
                />
                <div className="wam-hint">Valid for 10 minutes · Do not share with anyone</div>

                <button className="wam-btn-p" type="submit"
                  disabled={loading || otp.length !== 6}>
                  {loading
                    ? <><Spin/> Verifying…</>
                    : <><IconCheck/> Verify & Login</>
                  }
                </button>

                <div className="wam-resend">
                  {resendIn > 0
                    ? <>Resend OTP in <strong>{resendIn}s</strong></>
                    : <>Didn't receive?{' '}
                        <button type="button" className="wam-resend-btn"
                          onClick={handleSendOtp} disabled={loading}>
                          Resend via {channelLabel}
                        </button>
                      </>
                  }
                </div>

                <button type="button" className="wam-btn-g"
                  onClick={() => { setStep('phone'); setOtp(''); setError(''); }}>
                  <IconArrowLeft/> Change number or channel
                </button>
              </form>
            )}

            {/* ── STEP 3: Name ── */}
            {step === 'name' && (
              <form onSubmit={handleSaveName}>
                <div className="wam-sent-info">
                  <IconUser/>
                  Welcome! What should we call you?
                </div>

                <label className="wam-lbl">Your Full Name</label>
                <input
                  className="wam-inp"
                  type="text"
                  placeholder="e.g. Rahul Kumar"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  required
                  autoFocus
                />
                <div className="wam-hint" style={{marginBottom:'.85rem'}}>
                  Helps us personalise your experience
                </div>

                <button className="wam-btn-p" type="submit"
                  disabled={loading || !name.trim()}>
                  {loading ? <><Spin/> Saving…</> : <><IconCheck/> Start Shopping</>}
                </button>
              </form>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default WhatsAppAuthModal;